//import { GesturePlugin } from '@vueuse/gesture'
export default function (app) {
  //app.use(GesturePlugin)
}
